export const finalReportGrantSimpleApplication = {
  headerTitle: {
    nb: 'Sluttrapport for tilskudd',
    nn: 'Sluttrapport for tilskot',
    en: 'Final report for grant',
  },
  beforeYouBegin: {
    nb: 'Før du begynner',
    nn: 'Før du byrjar',
    en: 'Before you begin',
  },
  activityMustBeCompleted: {
    nb: 'Aktiviteten som tilskuddet gjelder må være gjennomført før du kan søke om utbetaling.',
    nn: 'Aktiviteten som tilskotet gjeld må vere gjennomført før du kan søkje om utbetaling.',
    en: 'The activity covered by the grant must be completed before you can apply for payment.',
  },
  bothFormsRequired: {
    nb: 'Du må fylle ut og sende inn både søknad om utbetaling og sluttrapport',
    nn: 'Du må fylle ut og sende inn både søknad om utbetaling og sluttrapport',
    en: 'You must complete and submit both the payment application and the final report',
  },
  paymentApplicationDescription: {
    nb: 'Søknaden om utbetaling inneholder utbetalingsdetaljer og dokumentasjon.',
    nn: 'Søknaden om utbetaling inneheld utbetalingsdetaljar og dokumentasjon.',
    en: 'The payment application contains payment details and documentation.',
  },
  finalReportDescription: {
    nb: 'Sluttrapporten skal beskrive gjennomførte aktiviteter, resultater og veien videre.',
    nn: 'Sluttrapporten skal beskrive gjennomførte aktivitetar, resultat og vegen vidare.',
    en: 'The final report should describe completed activities, results, and the way forward.',
  },
  customerDetails: {
    nb: 'Kundedetaljer',
    nn: 'Kundedetaljar',
    en: 'Customer details',
  },
  customerName: {
    nb: 'Kundenavn',
    nn: 'Kundenamn',
    en: 'Customer name',
  },
  referenceNumber: {
    nb: 'Referansenummer',
    nn: 'Referansenummer',
    en: 'Reference number',
  },
  instrument: {
    nb: 'Virkemiddel',
    nn: 'Virkemiddel',
    en: 'Funding instrument',
  },
  accountNumber: {
    nb: 'Kontonummer',
    nn: 'Kontonummer',
    en: 'Account number',
  },
  reporting: {
    nb: 'Sluttrapportering',
    nn: 'Sluttrapportering',
    en: 'Final reporting',
  },
  reportingDescription: {
    nb: 'Sluttrapporten gjelder aktiviteten som er gjennomført i forbindelse med tilskuddet. Du skal beskrive hva som er gjort, effekten, og planen videre. Svarene påvirker ikke utbetalingen.',
    nn: 'Sluttrapporten gjeld aktiviteten som er gjennomført i samband med tilskotet. Du skal beskrive kva som er gjort, effekten og planen vidare. Svara påverkar ikkje utbetalinga.',
    en: 'The final report concerns the activity completed in connection with the grant. Describe what was done, its effect, and the plan going forward. The answers do not affect the payment.',
  },
  completedActivity: {
    nb: 'Beskriv aktiviteten som er gjennomført',
    nn: 'Beskriv aktiviteten som er gjennomført',
    en: 'Describe the completed activity',
  },
  completedActivityHelp: {
    nb: 'Hva har dere gjort, når ble det gjort, og ble det gjennomført som planlagt? Beskriv også eventuelle avvik.',
    nn: 'Kva har de gjort, når blei det gjort, og blei det gjennomført som planlagt? Beskriv også eventuelle avvik.',
    en: 'What did you do, when was it done, and was it completed as planned? Also describe any deviations.',
  },
  completedActivityRequired: {
    nb: 'Du må beskrive aktiviteten som er gjennomført.',
    nn: 'Du må beskrive aktiviteten som er gjennomført.',
    en: 'You must describe the activity that has been carried out.',
  },
  activityEffect: {
    nb: 'Hvordan vurderer du effekten av aktiviteten?',
    nn: 'Korleis vurderer du effekten av aktiviteten?',
    en: 'How do you assess the effect of the activity?',
  },
  activityEffectHelp: {
    nb: 'For eksempel nye prosesser, økt kompetanse, ny innsikt, nye markeder, utvidet nettverk og lignende.',
    nn: 'Til dømes nye prosessar, auka kompetanse, ny innsikt, nye marknader, utvida nettverk og liknande.',
    en: 'For example, new processes, increased competence, new insights, new markets, expanded networks, and similar effects.',
  },
  activityEffectRequired: {
    nb: 'Du må vurdere effekten av aktiviteten.',
    nn: 'Du må vurdere effekten av aktiviteten.',
    en: 'You must assess the effect of the activity.',
  },
  furtherWorkPlan: {
    nb: 'Hvordan har aktiviteten påvirket plan for videre arbeid?',
    nn: 'Korleis har aktiviteten påverka planen for vidare arbeid?',
    en: 'How has the activity affected your plans for further work?',
  },
  furtherWorkPlanHelp: {
    nb: 'For eksempel planer for videreutvikling, kommersialisering, implementering, skalering og så videre.',
    nn: 'Til dømes planar for vidareutvikling, kommersialisering, implementering, skalering og så vidare.',
    en: 'For example, plans for further development, commercialisation, implementation, scaling, and so on.',
  },
  furtherWorkPlanRequired: {
    nb: 'Du må beskrive hvordan aktiviteten har påvirket planen for videre arbeid i prosjektet.',
    nn: 'Du må beskrive korleis aktiviteten har påverka planen for vidare arbeid i prosjektet.',
    en: 'You must describe how the activity has affected the plan for further work in the project.',
  },
  additionalInformation: {
    nb: 'Tilleggsinformasjon',
    nn: 'Tilleggsinformasjon',
    en: 'Additional information',
  },
  additionalInformationDescription: {
    nb: 'Ved behov kan du legge ved mer informasjon her.',
    nn: 'Ved behov kan du leggje ved meir informasjon her.',
    en: 'You can add more information here if needed.',
  },
  uploadAttachment: {
    nb: 'Last opp vedlegg',
    nn: 'Last opp vedlegg',
    en: 'Upload attachment',
  },
  uploadAttachmentHelp: {
    nb: 'For eksempel en rapport eller andre lignende dokumenter knyttet til aktiviteten.',
    nn: 'Til dømes ein rapport eller andre liknande dokument knytte til aktiviteten.',
    en: 'For example, a report or other similar documents related to the activity.',
  },
  otherComments: {
    nb: 'Andre kommentarer',
    nn: 'Andre kommentarar',
    en: 'Other comments',
  },
  confirmInformationTitle: {
    nb: 'Sjekk at alt stemmer',
    nn: 'Sjekk at alt stemmer',
    en: 'Check that everything is correct',
  },
  confirmInformationBody: {
    nb: 'Feil eller mangler i søknaden vil føre til lengre behandlingstid og forsinket utbetaling.',
    nn: 'Feil eller manglar i søknaden vil føre til lengre behandlingstid og forseinka utbetaling.',
    en: 'Errors or omissions in the application will lead to longer processing time and delayed payment.',
  },
  confirmSectionTitle: {
    nb: 'Bekreft før innsending',
    nn: 'Stadfest før innsending',
    en: 'Confirm before submission',
  },
  confirmDetails: {
    nb: 'Jeg bekrefter at opplysningene jeg har oppgitt stemmer',
    nn: 'Eg stadfestar at opplysningane eg har oppgitt stemmer',
    en: 'I confirm that the information I have provided is correct',
  },
  finalReminder: {
    nb: 'Husk at både søknad om utbetaling og sluttrapport må sendes inn før saken kan behandles ferdig og tilskudd utbetales.',
    nn: 'Hugs at både søknad om utbetaling og sluttrapport må sendast inn før saka kan behandlast ferdig og tilskot utbetalast.',
    en: 'Remember that both the payment application and final report must be submitted before the case can be fully processed and the grant paid.',
  },
  requiredConfirmation: {
    nb: 'Du må bekrefte opplysningene før du kan sende inn.',
    nn: 'Du må stadfeste opplysningane før du kan sende inn.',
    en: 'You must confirm the information before submitting.',
  },
  summaryTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  optionalLabel: {
    nb: 'Valgfritt',
    nn: 'Valfritt',
    en: 'Optional',
  },
} as const;
